import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Start by creating a `}<inlineCode parentName="p">{`plugins`}</inlineCode>{` folder and adding a `}<inlineCode parentName="p">{`posthog.js`}</inlineCode>{` file to that folder. In `}<inlineCode parentName="p">{`posthog.js`}</inlineCode>{`, initialize PostHog using the `}<inlineCode parentName="p">{`install`}</inlineCode>{` method with your project API key and host. You can find these in your `}<a parentName="p" {...{
        "href": "https://us.posthog.com/project/settings"
      }}>{`project settings`}</a>{`.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`// src/plugins/posthog.js
import posthog from 'posthog-js'

export default {
  install(Vue) {
    posthog.init('<ph_project_api_key>', {
      api_host: '<ph_client_api_host>',
      defaults: '<ph_posthog_js_defaults>'
    })

    Vue.prototype.$posthog = posthog
  }
}
`}</code></pre>
    <p>{`Next, in `}<inlineCode parentName="p">{`main.js`}</inlineCode>{`, import and use the plugin.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`// src/main.js
import Vue from 'vue'
import App from './App.vue'
import PosthogPlugin from './plugins/posthog'

Vue.config.productionTip = false
Vue.use(PosthogPlugin)

new Vue({
  render: h => h(App),
}).$mount('#app')
`}</code></pre>
    <p>{`This makes PostHog available as `}<inlineCode parentName="p">{`this.$posthog`}</inlineCode>{` in any Vue component.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      